import { default as ApiConstants } from 'shared/constants/ApiConstants.json';
import ApiUtils from 'shared/modules/ApiUtils';

const getOptionsAPI = (payload) =>
    ApiUtils.getRequest(`${ApiConstants.OPTIONS_ENDPOINT}/${payload.licencePlate}`);

export { getOptionsAPI };
